import React, { createContext, useContext, useState } from "react";
import { AppConfigDict } from "../model/AppConfig";
import { getLocale, getTarget } from '../utils/common';

// Create Context
const AppConfigContext = createContext<{ 
    appConfigDict: AppConfigDict;
    setAppConfigDict: React.Dispatch<React.SetStateAction<AppConfigDict>>
} | null>(null);

// Provide Context
export const AppConfigProvider = ({ children }: { children: React.ReactNode }) => {
    // Initialize app config state with proper fallback handling
    const [appConfigDict, setAppConfigDict] = useState<AppConfigDict>({
        country: getLocale(),
        target: getTarget() ?? "web", // Default to "web" if null
    });

    return (
        <AppConfigContext.Provider value={{ appConfigDict, setAppConfigDict }}>
        {children}
        </AppConfigContext.Provider>
    );
};
  
// Hook to use AppConfig
export const useAppConfig = () => {
    const context = useContext(AppConfigContext);
    if (!context) throw new Error("useAppConfig must be used within an AppConfigProvider");
    return context;
};
